import './entity.less';
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import get from 'lodash/get';
import moment from 'moment';
import SelectField from '../../../../../shared/form-elements/select/field';

const Entity = ({
	className,
	type,
	parentName,
	index,
	intl,
	fields,
	placeholder,
	entityLookup,
	savedTerms,
	onFetchDefaultTarget,
	onDeleteAlerts,
	isMaster
}) => (
	<tr
		className={`entity-target ${className}`}>
		<td className="entity-type">
			<Field
				name={`${parentName}.${type}`}
				placeholder={!!savedTerms[index] || placeholder}
				component={SelectField}
				disabled={!!savedTerms[index]}
				onChange={entity => onFetchDefaultTarget(index, entity[0])}
				multi={false}
				showLabel={false}
				options={entityLookup} />
		</td>
		<td className="datetime">
			<span className="date">{moment(get(savedTerms, `${index}.alert[0].created_at`)).format('DD.MM.YYYY')}</span>
			<span className="at">at</span>
			<span className="time">{moment(get(savedTerms, `${index}.alert[0].created_at`)).format('HH:mm')}</span>
		</td>
		<td className="datetime">
			{
				get(savedTerms, `${index}.alert[0].removed_at`) ?
					<div>
						<span className="date">{moment(get(savedTerms, `${index}.alert[0].removed_at`)).format('DD.MM.YYYY')}
						</span>
						<span className="at">at
						</span>
						<span className="time">{moment(get(savedTerms, `${index}.alert[0].removed_at`)).format('HH:mm')}
						</span>
					</div>
					: <span className="at">-</span>
			}
		</td>
		<td className="weeks-count">
			<div>
				<span>{get(savedTerms, `${index}.alert[0].count`, '0')}</span>
			</div>
		</td>
		<td className="entity-actions">
			<div className="actions__wrap">
				{!get(savedTerms, `${index}.alert[0].removed_at`, true) ? <span className="delete" onClick={e => {
					e.stopPropagation();
					const confirmWarning = isMaster ?
						intl('After confirmation this action, the alert will be closed . Are you sure ?') :
						intl('After confirmation this action, the alert will be closed . Are you sure ?');

					const alert = get(fields.getAll()[index], 'alert');

					if (savedTerms[index] && !confirm(confirmWarning)) {
						return;
					}

					fields.remove(index);
					savedTerms[index] && onDeleteAlerts(alert[0]['value']);
				}} /> : null }
			</div>
		</td>
	</tr>
);

Entity.propTypes = {
	className: PropTypes.string,
	type: PropTypes.string,
	parentName: PropTypes.string,
	index: PropTypes.any,
	intl: PropTypes.func,
	fields: PropTypes.object,
	placeholder: PropTypes.string,
	savedTerms: PropTypes.array,
	onFetchDefaultTarget: PropTypes.func,
	entityLookup: PropTypes.func,
	onDeleteAlerts: PropTypes.func,
	isMaster: PropTypes.bool
};

export default Entity;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/forms/alerts/entity.js